<template>
  <div class="vch-country-selector">
    <div class="vch-country-selector__details-row">
      <div class="vch-country-selector__product-img" v-if="productInfo">
        <img :src="productInfo.ProductImage" :alt="productInfo.ProductName" />
      </div>
      <div class="vch-country-selector__product-details">
        <div class="mt-lg product-info">
          <!-- <span class="product-info__label heading-xxs bg-liftactiv mb-xs">
            Neu</span
          > -->
          <h2 class="product-info__name" v-if="productInfo">
            <span class="vch-country-selector__productTitle">
              {{ productInfo.ProductName }}
            </span>
            <span class="vch-country-selector__productSubTitle">
              {{ productInfo.SubTitle }}
            </span>
          </h2>
        </div>
        <div class="mt-sm" v-if="productInfo">
          <rr-star-ratings>
            <div class="bvInlineRating productHeader">
              <div>
                <div
                  data-bv-show="rating_summary"
                  :data-bv-product-id="productInfo.ProductId"
                ></div>
              </div>
            </div>
          </rr-star-ratings>
        </div>
        <div class="vch-country-selector__titles">
          <p class="heading-xs">{{ firstTitle }}</p>
          <p class="heading-xxs mt-xs">{{ firstDescription }}</p>
        </div>
        <div class="vch-country-selector__btn-row mt-xxs" v-if="country">
          <button
            class="button -primary"
            @click="onCountrySelected(value)"
            v-for="[key, value] in Object.entries(country)"
          >
            {{ value }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'vch-cc-modal-country-selector',
  components: {},
  data() {
    return {};
  },
  props: {
    firstTitle: {
      type: String,
      required: true,
    },
    firstDescription: {
      type: String,
      required: true,
    },
    country: {
      type: Object,
      required: true,
    },
    productInfo: {
      type: Object,
      required: true,
    },
  },
  mounted() {},
  methods: {
    onCountrySelected(selectedCountry) {
      this.$emit('countrySelect', selectedCountry);
      this.$forceUpdate();
      var destinationUrl = window.location.href;
      pushEvent({
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'where to shop',
        eventAction: 'click to buy::select::' + selectedCountry.toLowerCase(),
        eventLabel: selectedCountry.toLowerCase() + '::' + destinationUrl,
        event_name: 'where_to_shop',
        cta_name: selectedCountry.toLowerCase(),
        link_url: destinationUrl,
      });
    },
  },
};
</script>

<style lang="scss" src="./cc-modal-country-selector.scss"></style>
